import { UploadOutlined } from "@ant-design/icons";
import { ProgressIndicator } from "@fluentui/react";
import { Button, Layout, notification } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext, useEffect } from "react";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
import { EbendoDailyProductionUpload } from "./EbendoDailyProductionUpload";
import { EbendoProductionGrid } from "./EbendoProductionGrid";
import { EbendoRemarkPane } from "./EbendoRemarkPane";
import { EbendoSQuery } from "./EbendoSQuery";
import { RequestDialog } from "./../approvals/RequestDialog";
import { EbendoDailyProductionDetail } from "../approvals/ebendo/EbendoDailyProductionDetail";
import { RythmBaseView } from "./visualizations/oil-rythm-plots/RythmBaseView";
import { EbendoWellAllocationExport } from "./EbendoWellAllocationExport";

const ebendoDailyProductionStoreCtx = createContext(EbendoDailyProductionStore);

const { Content } = Layout;
export const EbendoDailyProductionBase = observer(() => {
  const ebendoDailyProductionStore = useContext(ebendoDailyProductionStoreCtx);

  useEffect(() => {
    async function loadInitailWellParameters() {
      try {
        if (!ebendoDailyProductionStore.wellParametersLoaded) {
          await ebendoDailyProductionStore.loadInitialWellParameters();
        }
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadInitailWellParameters();
  }, []);
  return (
    <Layout
      style={{
        background: "#fff",
        padding: "10px",
        borderTop: "2px solid #F29C1F",
      }}
    >
      <Content>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm6">
              <SubPageHeaderTitle
                title={`${ebendoDailyProductionStore.gridHeaderText}`}
              />
            </div>
            <div className="ms-Grid-col ms-sm3">
              {ebendoDailyProductionStore.isExporting && (
                <ProgressIndicator
                  description="exporting, please wait..."
                  styles={{ root: { textAlign: "center" } }}
                ></ProgressIndicator>
              )}
            </div>
            <div className="ms-Grid-col ms-sm3" style={{ textAlign: "right" }}>
              {ebendoDailyProductionStore.dailyProductions.size > 0 && (
                <Button
                  type="primary"
                  icon={<UploadOutlined />}
                  onClick={async () => {
                    await ebendoDailyProductionStore.loadInitialWellParameters();
                    ebendoDailyProductionStore.clearFormValues();

                    ebendoDailyProductionStore.sheetName = "";
                    ebendoDailyProductionStore.showEbendoDailyProductionDialog = true;
                  }}
                >
                  Upload EBENDO Field Daily Production & Evacuation
                </Button>
              )}
            </div>
          </div>

          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <EbendoProductionGrid />

              <EbendoDailyProductionUpload />
              <EbendoRemarkPane />
              <EbendoSQuery />
              <RequestDialog />
              <EbendoDailyProductionDetail />
              <EbendoWellAllocationExport />
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm12">
                {/* PLOT WRAPPERS */}
                <RythmBaseView />
              </div>
            </div>
          </div>
        </div>
      </Content>
    </Layout>
  );
});

